import api from '@/api'
export default {
  async analyse(shortCode) {
    let response = await api.request('post', `/api/v1/content-analysis`, true, {
      short_code: shortCode
    })
    if (response.status !== 200) {
      throw new Error('External Error')
    }
    return response.data
  },

  async oembed(shortcode) {
    let response = await api.request('get', `/api/v1/content-analysis/helper/oembed?short_code=${shortcode}`, true)
    if (response.status !== 200) {
      throw new Error('External Error')
    }
    return response.data
  },

  async oembedOpen(shortcode) {
    let response = await api.request('get', `/api/v1/content-analysis-open/helper/oembed?short_code=${shortcode}`, true)
    if (response.status !== 200) {
      throw new Error('External Error')
    }
    return response.data
  },

  async getHistories() {
    let response = await api.request('get', `/api/v1/content-analysis/history`, true)
    if (response.status !== 200) {
      throw new Error('External Error')
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/components/views/ContentAnalysis/contentAnalysisAPI.js